import { useEffect, useRef } from 'react';

/**
 * Store and access the previous value of a variable.
 * @param {T} value - Current value to track and return the previous value of.
 * @returns The previous value of the input `value` parameter.
 */
function usePrevious<T>(value: T) {
  const ref = useRef<T>();

  useEffect(() => {
    ref.current = value;
  }, [value]);

  return ref.current;
}

export default usePrevious;
